import { render, staticRenderFns } from "./s2-2.vue?vue&type=template&id=07caf789&scoped=true&"
import script from "./s2-2.vue?vue&type=script&lang=js&"
export * from "./s2-2.vue?vue&type=script&lang=js&"
import style0 from "./s2-2.vue?vue&type=style&index=0&id=07caf789&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07caf789",
  null
  
)

export default component.exports